import getTurnAroundTime from "@custom/rtk-apis/analytics/getTurnAroundTime";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const getTurnAroundTimeSlice = createSlice({
  name: "getTurnAroundTimeSlice",
  initialState,
  reducers: {
    clearTurnAroundTime: state => {
      state.status = '';
      state.result = '';
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTurnAroundTime.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getTurnAroundTime.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = "SUCCESS";
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(getTurnAroundTime.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default getTurnAroundTimeSlice.reducer;
export const { clearTurnAroundTime } = getTurnAroundTimeSlice.actions;
